export const authProviders = {
  Okta: 'okta',
  Entra: 'entra',
};
